
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chinna-erica",
      function () {
        return require("private-next-pages/chinna-erica/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chinna-erica"])
      });
    }
  